var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _path14, _path15, _path16, _path17, _rect4, _path18, _path19, _path20, _path21, _path22, _rect5, _path23, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingBotLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 143,
    viewBox: "0 0 145 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35429 38.9443C6.7649 27.5756 15.3941 18.6366 19.8141 14.5811C32.7723 5.39238 39.6515 4.40356 48.3284 3.15631L48.4991 3.13178C62.0121 1.18891 91.8303 1.3679 104.206 5.03778C119.676 9.62513 128.516 18.7998 133.74 28.3734C138.964 37.947 144.991 53.1052 141.174 83.4217C138.12 107.675 125.302 116.53 114.453 122.514L96.5716 131.689L75.0745 141.262C65.029 137.207 41.1207 126.942 25.8516 118.325C6.76514 107.555 3.1488 88.2085 2.14428 83.4217C0.00968647 73.2497 1.75529 51.2014 4.35429 38.9443Z",
    fill: "url(#paint0_linear_1777_10695)",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6449 83.1992H3.01953L3.62013 86.2442L4.42092 89.6951L5.62211 93.349L7.22369 97.2059C17.9543 97.3683 26.3092 97.1383 27.4437 96.5969C29.5258 93.8362 29.0453 85.9735 28.6449 83.1992Z",
    stroke: "black",
    strokeWidth: 1.13889
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1057 35.6865C34.0179 26.0626 21.5914 19.6919 16.7734 18.1547C29.816 3.41467 46.1081 2.60187 62.0579 1.80615L62.4039 1.78889C75.4502 1.13741 99.6315 1.96641 111.989 7.80396C126.845 14.8215 135.075 27.4529 138.89 39.2824C142.704 51.1118 143.507 71.3622 141.901 81.5877C139.999 93.6963 136.49 113.198 119.618 118.078C100.948 123.478 77.2594 121.674 57.3852 117.076C39.8053 113.008 37.9129 93.6351 37.1097 85.413L37.1094 85.4103C36.3064 77.1898 38.7154 47.7165 36.1057 35.6865Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.36667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.2305,
    y: 95.4219,
    width: 18.9475,
    height: 4.88968,
    rx: 1.48056,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4921 90.2449C53.8429 83.4538 42.4603 82.7666 37.25 83.3729C37.8512 95.0956 38.6528 100.957 43.8631 108.233C48.0027 114.014 54.6845 116.924 61.6984 117.733V101.159C61.6984 94.4893 59.4941 91.9292 58.4921 90.2449Z",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5259 37.5955C27.3361 34.3579 19.4754 29.9844 15.2081 27.8828L10.6602 40.1515C13.7595 40.5604 24.641 46.4562 29.8628 55.9985L32.0525 44.5818C31.9402 43.8434 31.5348 40.5657 29.5259 37.5955Z",
    fill: "#CAA2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7811 114.725L8.21484 98.1719L9.33817 100.248L10.622 102.483C12.3298 105.024 14.9419 108.943 19.2104 112.542C22.6261 115.422 25.3699 117.297 32.2014 120.516L40.4562 124.76L61.2373 125.371L84.4633 126.135L104.022 126.746L116.857 120.175L118.233 119.106C102.526 123.369 73.7448 121.671 57.1786 118.621L33.7811 114.725Z",
    fill: "#7057F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7786 127.816H62.3725L71.4766 137.29L49.7786 127.816Z",
    fill: "#383740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0433 86.2539H6.6875L8.21559 90.9806L25.5339 91.1436C26.3489 90.1005 26.3829 87.4492 26.0433 86.2539Z",
    fill: "#826CF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5288 128.43H65.8323L75.4492 138.82L52.5288 128.43Z",
    fill: "#634AE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7773 125.371L105.705 127.446L98.6915 131.181L96.2869 132.426L94.6839 133.256L75.0465 142.179L65.6285 138.237L56.2106 133.879L38.7773 125.371Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.911111
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7781 128.43H64.9977L74.2266 138.82L49.7781 128.43Z",
    fill: "#644AE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6955 75.2539H85.8419V82.2828L74.6873 98.4799L54.2118 84.2693L44.5852 82.2828L38.3203 79.074L39.6955 75.2539Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.075 45.3047H87.3697V36.2411L76.1793 15.3554L55.6379 33.6796L45.9804 36.2411L39.6953 40.3788L41.075 45.3047Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4727,
    y: 47.1367,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6719,
    y: 45.3047,
    width: 7.02892,
    height: 28.1157,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6916 74.4866L41.8313 70.0553L42.4426 72.3474L43.8173 74.0275L45.3453 74.9444L46.8733 75.4028L43.0263 78.0626L39.6916 74.4866Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2885 75.2162L88.5019 69.1783L87.828 70.3627L87.5224 71.8907L86.6983 73.4187L85.3832 74.4883L84.008 75.0995L82.7855 75.4052L81.5632 76.2848L86.6983 79.9695L91.2885 75.2162Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.883 74.9453H137.029V81.9742L125.875 98.1713L105.399 83.9607L95.7727 81.9742L89.5078 78.7654L90.883 74.9453Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2625 44.9961H138.557L134.279 35.9325L119.915 18.8668L106.825 33.371L97.1679 35.9325L90.8828 40.0702L92.2625 44.9961Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.6602,
    y: 46.832,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.883 74.1819L93.0227 69.7506L93.634 72.0427L95.0087 73.7229L96.5367 74.6397L98.0647 75.0981L94.2178 77.758L90.883 74.1819Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.544 75.1005L139.689 68.8737L139.016 70.058L138.71 71.586L137.886 73.114L136.571 74.1836L135.195 74.7949L133.973 75.1005L132.751 75.9801L137.886 79.6648L140.544 75.1005Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8289 45.3026H119.76H134.124L136.416 47.4419L138.249 49.8867L138.555 43.1634L134.124 36.239L118.996 17.951L102.392 33.6776L92.7343 36.239L86.4492 40.3768L87.8289 45.3026Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.883 75.2539H137.029V82.2828L125.875 98.4799L105.399 84.2693L95.7727 82.2828L89.5078 79.074L90.883 75.2539Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4101 78.3512L96.9395 75.7993L95.8549 75.1821L94.4556 74.9023L93.0562 74.1476L92.0767 72.9432L91.5169 71.6838L91.2371 70.5643L90.4315 69.4449L87.0571 74.1476L91.4101 78.3512Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.9805,
    y: 46.2188,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.793 44.8438L139.627 46.6774L141.46 60.124V67.6113L141.155 73.1122L139.932 80.294L133.056 77.3907L132.598 75.7099L134.89 74.6403L137.335 72.8066V57.3736V49.8862L137.793 44.8438Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_10695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1367,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1777_10695)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.905,
    cy: 61.0429,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#0154FA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1777_10695)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.9073,
    cy: 60.4306,
    rx: 12.0714,
    ry: 8.09854,
    fill: "#378BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.7606 56.3785C60.5918 56.8761 59.9575 57.767 59.8285 59.0159C59.7517 59.7418 59.9721 60.4114 60.1971 61.0817C60.2255 61.1673 60.2478 61.2545 60.2808 61.3378C60.469 61.806 60.3684 62.1377 59.9222 62.4347C59.3355 62.825 59.0713 63.4098 59.0651 64.1418C59.0567 65.214 58.6144 66.1119 57.7735 66.7761C57.3365 67.1217 57.1023 67.5151 57.123 68.0875C57.1445 68.6961 57.024 68.7894 56.4042 68.791C56.289 68.791 56.1738 68.7794 56.0586 68.791C55.783 68.8211 55.7039 69.0124 55.8498 69.2538C55.9419 69.4035 56.0571 69.5554 56.0886 69.7167C56.1654 70.1139 55.9703 70.3276 55.5702 70.3338C54.7639 70.3374 53.9575 70.3374 53.1512 70.3338C52.4808 70.3284 52.0646 69.8208 52.2589 69.1836C52.7066 67.718 53.1097 66.2269 53.8546 64.87C54.3569 63.9559 55.0895 63.2447 55.8759 62.579C56.4626 62.083 57.0585 61.5924 57.5922 61.0424C57.8192 60.7867 57.9621 60.4669 58.0015 60.1267C58.0484 59.7217 58.1283 59.4625 58.5875 59.471C58.6407 59.4664 58.6923 59.4502 58.7387 59.4235C58.7851 59.3969 58.8252 59.3605 58.8563 59.3168C58.3809 59.3168 57.9056 59.3044 57.431 59.3168C56.9564 59.3291 56.5793 59.2435 56.3789 58.739C56.3259 58.6048 56.1224 58.4991 55.965 58.4435C55.197 58.172 55.0104 57.73 55.369 56.9872C55.4251 56.8714 55.4835 56.7557 55.5495 56.647C55.7484 56.3153 55.8966 56.0059 55.5211 55.6704C55.3468 55.5161 55.399 55.2847 55.5925 55.1304C56.1616 54.6846 56.4111 54.0921 56.5033 53.3809C56.6569 52.1744 58.0131 51.4987 58.8839 51.7772C59.5981 52.0047 60.3307 52.1791 61.0342 52.429C61.6285 52.6388 62.0893 53.06 62.4165 53.5969C62.9248 54.4238 63.6452 54.9337 64.5667 55.2168C65.493 55.4873 66.3326 55.9969 67.0019 56.6948C67.3812 57.0944 67.8044 57.4531 68.1714 57.8635C68.6545 58.4034 69.2343 58.6117 69.9485 58.5785C70.8439 58.5377 71.7393 58.5369 72.5495 59.0367C73.7728 59.7919 74.5116 60.8333 74.5776 62.3144C74.5986 62.5668 74.6887 62.8084 74.838 63.0125C75.1191 63.4103 75.4333 63.7834 75.7772 64.1279C76.4361 64.7782 76.5451 65.6707 76.8661 66.4722C76.9849 66.7818 77.0875 67.0975 77.1733 67.4179C77.4175 68.2911 77.1449 69.0864 76.7824 69.8617C76.6027 70.2474 76.2494 70.3708 75.8609 70.38C75.1444 70.397 74.4271 70.3932 73.7106 70.3893C73.4695 70.3893 73.2406 70.3268 73.1731 70.0499C73.1009 69.7575 72.9611 69.4467 73.3013 69.2137C73.3849 69.1541 73.4653 69.0902 73.5424 69.0224C73.835 68.7748 73.8496 68.5835 73.5816 68.3181C73.3259 68.0666 73.051 67.8352 72.7906 67.5899C72.1947 67.0291 72.1225 66.2338 72.6125 65.5843C72.9757 65.0991 73.279 64.5892 73.3512 63.9505C73.0248 64.4241 72.7369 64.8978 72.3928 65.322C72.0787 65.7077 71.6871 66.0286 71.3523 66.402C70.7778 67.0376 70.5398 67.8453 70.2602 68.6305C70.1535 68.9329 70.0491 69.2361 69.9323 69.5346C69.7119 70.0954 69.3564 70.3368 68.7628 70.3376C68.0716 70.3376 67.3805 70.3245 66.6893 70.3422C66.4013 70.35 66.2708 70.2173 66.1955 69.9681C66.1203 69.719 66.0081 69.4474 66.3161 69.253C66.8152 68.9383 66.9581 68.4631 67.0479 67.8946C67.2438 66.6604 67.2737 65.3807 67.9441 64.2691C68.229 63.797 68.5331 63.3365 68.8265 62.8698C68.9256 62.7155 69.0192 62.552 69.1152 62.3923L69 62.3113C68.5393 62.9469 68.0432 63.5633 67.6177 64.2236C67.2676 64.7635 67.1508 64.9093 66.677 64.8052C65.7386 64.5985 65.5351 64.4087 65.4391 63.8726C65.3492 63.3758 65.1388 62.8952 64.9415 62.4255C64.5836 61.5769 64.3801 60.6991 64.4116 59.7711C64.4133 59.611 64.3873 59.4518 64.3348 59.3006C64.1251 60.3226 64.1482 61.3201 64.5345 62.3036C64.7738 62.8963 64.9717 63.5052 65.1265 64.1256C65.3707 65.1446 65.0881 66.0803 64.5245 66.9327C64.172 67.4665 63.7911 67.9826 63.4109 68.4971C63.1975 68.7848 63.1506 69.0371 63.447 69.3009C63.6813 69.5091 63.735 69.7807 63.6221 70.0723C63.5092 70.3638 63.2558 70.3422 63.0078 70.3415C62.163 70.3376 61.3183 70.3415 60.4736 70.3415C59.9805 70.3415 59.8761 70.2427 59.8838 69.7622C59.8904 69.2903 59.8169 68.8207 59.6664 68.3737C59.5406 67.949 59.5287 67.4985 59.6319 67.0677C59.9391 65.7478 60.3538 64.4519 60.6686 63.1336C60.8691 62.292 60.6901 61.4635 60.4121 60.6482C59.8185 58.9071 60.1933 57.6737 61.6262 56.5066C61.6792 56.4618 61.7184 56.4186 61.7606 56.3785Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1777_10695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.6484,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1777_10695)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.413,
    cy: 61.0429,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#0154FA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1777_10695)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.72,
    cy: 60.7353,
    rx: 12.0714,
    ry: 8.09854,
    fill: "#378BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.097 56.3785C110.928 56.8761 110.293 57.767 110.164 59.0159C110.088 59.7418 110.308 60.4114 110.533 61.0817C110.561 61.1673 110.584 61.2545 110.617 61.3378C110.805 61.806 110.704 62.1377 110.258 62.4347C109.671 62.825 109.407 63.4098 109.401 64.1418C109.393 65.214 108.95 66.1119 108.109 66.7761C107.672 67.1217 107.438 67.5151 107.459 68.0875C107.48 68.6961 107.36 68.7894 106.74 68.791C106.625 68.791 106.51 68.7794 106.395 68.791C106.119 68.8211 106.04 69.0124 106.186 69.2538C106.278 69.4035 106.393 69.5554 106.425 69.7167C106.501 70.1139 106.306 70.3276 105.906 70.3338C105.1 70.3374 104.293 70.3374 103.487 70.3338C102.817 70.3284 102.401 69.8208 102.595 69.1836C103.043 67.718 103.446 66.2269 104.191 64.87C104.693 63.9559 105.425 63.2447 106.212 62.579C106.799 62.083 107.394 61.5924 107.928 61.0424C108.155 60.7867 108.298 60.4669 108.337 60.1267C108.384 59.7217 108.464 59.4625 108.923 59.471C108.977 59.4664 109.028 59.4502 109.075 59.4235C109.121 59.3969 109.161 59.3605 109.192 59.3168C108.717 59.3168 108.241 59.3044 107.767 59.3168C107.292 59.3291 106.915 59.2435 106.715 58.739C106.662 58.6048 106.458 58.4991 106.301 58.4435C105.533 58.172 105.346 57.73 105.705 56.9872C105.761 56.8714 105.819 56.7557 105.885 56.647C106.084 56.3153 106.233 56.0059 105.857 55.6704C105.683 55.5161 105.735 55.2847 105.928 55.1304C106.497 54.6846 106.747 54.0921 106.839 53.3809C106.993 52.1744 108.349 51.4987 109.22 51.7772C109.934 52.0047 110.667 52.1791 111.37 52.429C111.964 52.6388 112.425 53.06 112.752 53.5969C113.261 54.4238 113.981 54.9337 114.903 55.2168C115.829 55.4873 116.669 55.9969 117.338 56.6948C117.717 57.0944 118.14 57.4531 118.507 57.8635C118.99 58.4034 119.57 58.6117 120.284 58.5785C121.18 58.5377 122.075 58.5369 122.885 59.0367C124.109 59.7919 124.848 60.8333 124.914 62.3144C124.935 62.5668 125.025 62.8084 125.174 63.0125C125.455 63.4103 125.769 63.7834 126.113 64.1279C126.772 64.7782 126.881 65.6707 127.202 66.4722C127.321 66.7818 127.423 67.0975 127.509 67.4179C127.753 68.2911 127.481 69.0864 127.118 69.8617C126.939 70.2474 126.585 70.3708 126.197 70.38C125.48 70.397 124.763 70.3932 124.047 70.3893C123.805 70.3893 123.577 70.3268 123.509 70.0499C123.437 69.7575 123.297 69.4467 123.637 69.2137C123.721 69.1541 123.801 69.0902 123.878 69.0224C124.171 68.7748 124.186 68.5835 123.918 68.3181C123.662 68.0666 123.387 67.8352 123.127 67.5899C122.531 67.0291 122.458 66.2338 122.948 65.5843C123.312 65.0991 123.615 64.5892 123.687 63.9505C123.361 64.4241 123.073 64.8978 122.729 65.322C122.415 65.7077 122.023 66.0286 121.688 66.402C121.114 67.0376 120.876 67.8453 120.596 68.6305C120.489 68.9329 120.385 69.2361 120.268 69.5346C120.048 70.0954 119.692 70.3368 119.099 70.3376C118.408 70.3376 117.716 70.3245 117.025 70.3422C116.737 70.35 116.607 70.2173 116.531 69.9681C116.456 69.719 116.344 69.4474 116.652 69.253C117.151 68.9383 117.294 68.4631 117.384 67.8946C117.58 66.6604 117.61 65.3807 118.28 64.2691C118.565 63.797 118.869 63.3365 119.162 62.8698C119.261 62.7155 119.355 62.552 119.451 62.3923L119.336 62.3113C118.875 62.9469 118.379 63.5633 117.954 64.2236C117.604 64.7635 117.487 64.9093 117.013 64.8052C116.075 64.5985 115.871 64.4087 115.775 63.8726C115.685 63.3758 115.475 62.8952 115.277 62.4255C114.92 61.5769 114.716 60.6991 114.748 59.7711C114.749 59.611 114.723 59.4518 114.671 59.3006C114.461 60.3226 114.484 61.3201 114.87 62.3036C115.11 62.8963 115.308 63.5052 115.462 64.1256C115.707 65.1446 115.424 66.0803 114.86 66.9327C114.508 67.4665 114.127 67.9826 113.747 68.4971C113.533 68.7848 113.487 69.0371 113.783 69.3009C114.017 69.5091 114.071 69.7807 113.958 70.0723C113.845 70.3638 113.592 70.3422 113.344 70.3415C112.499 70.3376 111.654 70.3415 110.809 70.3415C110.316 70.3415 110.212 70.2427 110.22 69.7622C110.226 69.2903 110.153 68.8207 110.002 68.3737C109.877 67.949 109.865 67.4985 109.968 67.0677C110.275 65.7478 110.69 64.4519 111.005 63.1336C111.205 62.292 111.026 61.4635 110.748 60.6482C110.154 58.9071 110.529 57.6737 111.962 56.5066C112.015 56.4618 112.054 56.4186 112.097 56.3785Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1777_10695",
    x: 35.008,
    y: 37.258,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_10695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1777_10695",
    x: 45.4787,
    y: 44.9748,
    width: 38.859,
    height: 30.9098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_10695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1777_10695",
    x: 84.5158,
    y: 37.258,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_10695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1777_10695",
    x: 95.2912,
    y: 45.2795,
    width: 38.859,
    height: 30.9098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_10695"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_10695",
    x1: 15.8565,
    y1: 20.3954,
    x2: 55.3782,
    y2: 141.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_10695"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1367,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1777_10695"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.6445,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBotLogo4);
export default __webpack_public_path__ + "static/media/TradingBotLogo_4.31074b78891621a1703e10107d28fc7d.svg";
export { ForwardRef as ReactComponent };